import { useState } from 'react'
import { OutsiteElementClick } from '@/helpers'

const useOpen = (): UseOpenFunctionReturnTypes => {
    const [open, setOpen] = useState<boolean>(false)

    const DropdownCloser = OutsiteElementClick(() => setOpen(false))

    return {
        open,
        setOpen,
        ref: DropdownCloser
    }
}

export default useOpen
